import { render, staticRenderFns } from "./CreditNoteFooter.vue?vue&type=template&id=2ad68de8&scoped=true&"
import script from "./CreditNoteFooter.vue?vue&type=script&lang=js&"
export * from "./CreditNoteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad68de8",
  null
  
)

export default component.exports